import React from 'react';

interface PlanFeaturesProps {
  features: string[];
}

export const PlanFeatures: React.FC<PlanFeaturesProps> = ({ features }) => (
  <div className="px-6 py-8">
    <div className="font-semibold mb-1">Covered features & incomes:</div>
    <ul className="list-inside space-y-1 text-sm text-grey-700">
      {features.map((feat, idx) => (
        <li key={idx} className="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="text-green-500 w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
          {feat}
        </li>
      ))}
    </ul>
  </div>
);
